import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Giulia',
    age: '34',
    city: 'Milano',
    text: "Finalmente ho una struttura chiara per le mie lezioni. I miei studenti sono più coinvolti e anch'io mi sento molto più sicura quando insegno."
  }, {
    name: 'Marco',
    age: '41',
    city: 'Roma',
    text: 'Questo pack mi ha aiutato a rendere le lezioni molto più dinamiche. Gli studenti partecipano di più e noto progressi più rapidi.'
  }, {
    name: 'Elena',
    age: '29',
    city: 'Torino',
    text: 'Prima improvvisavo spesso. Adesso ho un metodo semplice da seguire e le lezioni risultano molto più professionali.'
  }, {
    name: 'Davide',
    age: '46',
    city: 'Napoli',
    text: 'Ho trovato idee pratiche, immediate e davvero utili. Consigliatissimo a chi insegna musica e vuole fare un salto di qualità.'
  }, {
    name: 'Francesca',
    age: '38',
    city: 'Bologna',
    text: 'Una risorsa completa e ben fatta. Mi ha aiutata tantissimo a motivare meglio i miei studenti e a organizzare tutto con più chiarezza.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-gray-50" data-id="element-283">
      <div className="max-w-6xl mx-auto" data-id="element-284">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-285">
          Cosa stanno dicendo altri insegnanti di musica
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-286">
          {testimonials.map((t, index) => <div key={index} className={`bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-287">
              <div className="flex gap-1 mb-4" data-id="element-288">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-289" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-290">"{t.text}"</p>
              <div className="border-t border-gray-100 pt-4 mt-auto" data-id="element-291">
                <p className="font-bold text-gray-900" data-id="element-292">
                  {t.name}, {t.age} anni
                </p>
                <p className="text-sm text-gray-500" data-id="element-293">{t.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}